import React from 'react';
import Button from '../../components/properties/controls/Button';
import styles from './ImageToolPanel.module.css';

const ImageCropPanel = ({ onApply, onCancel, onReset }) => (
  <div className={styles.toolContent}>
    <div className={styles.toolNote}>
      Drag the crop handles on the canvas to adjust your image.
    </div>
    <div className={styles.toolActions}>
      <Button onClick={onApply}>Apply</Button>
      <Button onClick={onCancel} variant="secondary">
        Cancel
      </Button>
      <Button onClick={onReset} variant="secondary">
        Reset
      </Button>
    </div>
  </div>
);

export default ImageCropPanel;
